import axios from 'axios'

const photonClient = axios.create({
  baseURL: 'https://photon.komoot.io/api',
  timeout: 10000,
})

export default photonClient
